module.exports = __webpack_public_path__ + "static/media/luvgautam.253b766f.jpg";